/**
 * Pool-pricing contracts. These mirror the locates-ws `/v1/inventory`
 * pricing endpoints (`model/pool-pricing.ts` and
 * `servers/http/contracts/inventory.ts`); the backend will publish them via
 * `@thinkalpha/locates-ws-client`, at which point this file should be
 * replaced by imports from the client package.
 */
/** Every {@link PoolPricingMethod}, for iteration in UI code. */
export const POOL_PRICING_METHODS = ['admin', 'cached', 'reference', 'fair-value'];
/** Every {@link BorrowStatusKey}, in the design's display order. */
export const BORROW_STATUS_KEYS = ['ETB', 'Locate Required', 'Preborrow'];
//# sourceMappingURL=lab-pool-pricing.js.map